import { type OperationId, operationIds } from "@gen/app-access-config";

import { ActionFormWithDescription } from "./ActionFormWithDescription";
import { useSubmitOrderIssueMutation } from "./useSubmitOrderIssueMutation";

interface SubmitOrderIssueActionProps {
  canExecuteForStatus: (operationId: OperationId) => boolean;
  isF2f?: boolean;
  transactionId: number;
}

export function SubmitOrderIssueAction({
  canExecuteForStatus,
  isF2f,
  transactionId,
}: SubmitOrderIssueActionProps) {
  const { submitOrderIssue, isLoading } = useSubmitOrderIssueMutation({
    transactionId: transactionId,
    isF2f: !!isF2f,
  });

  const canExecute = canExecuteForStatus(
    isF2f
      ? operationIds["core_admin.submitF2fOrderIssue"]
      : operationIds["core_admin.submitOnlineOrderIssue"],
  );

  return (
    <ActionFormWithDescription
      title="Submit Order Issue"
      buttonText="Submit order issue"
      canExecute={canExecute}
      isLoading={isLoading}
      onSubmit={submitOrderIssue}
      dataTestId="submit-order-issue"
    />
  );
}
